import { generateKeys } from '../utils';
export const mailchimpMergeFields = generateKeys({
    clientId: {
        value: 'CLIENT_ID',
    },
    firstName: {
        value: 'FNAME',
    },
    lastName: {
        value: 'LNAME',
    },
    company: {
        value: 'COMPANY',
    },
    country: {
        value: 'COUNTRY',
    },
    signedUp: {
        value: 'SIGNED_UP',
    },
    lastSeen: {
        value: 'LAST_SEEN',
    },
    language: {
        value: 'LANGUAGE',
    },
    campaign: {
        value: 'CAMPAIGN',
    },
    binary: {
        value: 'BINARY',
    },
    forex: {
        value: 'FOREX',
    },
    forexDemo: {
        value: 'FOREX_DEMO',
    },
    pamm: {
        value: 'PAMM',
    },
    affiliate: {
        value: 'AFF',
    },
    bdxcoin: {
        value: 'BDXCOIN',
    },
    balanceForex: {
        value: 'FOREX_BAL',
    },
    balanceBinary: {
        value: 'BINARY_BAL',
    },
    gold: {
        value: 'GOLD',
    },
});
